import React from 'react'
import {withRouter } from 'react-router-dom'

const LoginForm = (props) => {
    return (
        <form onSubmit={props.onSubmit}>
            <div className="form-input">
                <label>Firstname</label>
                <input type="text" name="firstname" value={props.firstname} onChange={props.onChange} />
                <span className="error">{props.errors.firstname}</span>
            </div>
            <div className="form-input">
                <label>Middlename</label>
                <input type="text" name="middlename" value={props.middlename} onChange={props.onChange} />
                <span className="error">{props.errors.middlename}</span>
            </div>
            <div className="form-input">
                <label>Lastname</label>
                <input type="text" name="lastname" value={props.lastname} onChange={props.onChange} />
                <span className="error">{props.errors.lastname}</span>
            </div>
            <div className="form-input">
                <label>Phone</label>
                <input type="text" name="phone" value={props.phone} onChange={props.onChange} />
                <span className="error">{props.errors.phone}</span>
            </div>
            <div className="form-input">
                <label>Enrollment Number</label>
                <input type="text" name="enrollmentNumber" value={props.enrollmentNumber} onChange={props.onChange} />
                <span className="error">{props.errors.enrollmentNumber}</span>
            </div>
            <div className="form-input">
                <label>Choose Password</label>
                <input type="password" name="password" value={props.password} onChange={props.onChange} />
                <span className="error">{props.errors.password}</span>
            </div>
            <div className="actions">
                <button className={props.processing ? 'disabled' : ''}>Register</button>
            </div>
        </form>
    )
}

export default withRouter(LoginForm)